export default __webpack_public_path__ + "static/media/misc-pantry1-1440w.66d4210a.webp";